var r = "ResizeObserver loop completed with undelivered notifications.", t = function() {
  var e;
  typeof ErrorEvent == "function" ? e = new ErrorEvent("error", {
    message: r
  }) : (e = document.createEvent("Event"), e.initEvent("error", !1, !1), e.message = r), window.dispatchEvent(e);
};
export {
  t as deliverResizeLoopError
};
